import React from 'react';
import { Paragraph2, Button, Subhead1 } from '../../theme/styles';
import './Form.css';

const createButtons = (groupName, inputType, clickFunction, buttonStyle, disabled, uniqueKey, hideRadioInput) => (item) => {
    switch (inputType) {
        case 'radio':
        case 'checkbox': {
            const id = `${item.value}-${inputType}-${uniqueKey}`;
            return (
                <div key={item.key} className={[`${inputType}-item-container`, hideRadioInput && 'hideRadioInput'].filter(Boolean).join(' ')}>
                    <input
                        id={id}
                        className={`${inputType}-input`}
                        type={inputType}
                        name={groupName}
                        value={item.value}
                        checked={item.checked}
                        // UPN-23560 - add OnChange or readOnly to prevent error in tests
                        onClick={clickFunction ? () => clickFunction(item) : null}
                        disabled={disabled}
                    />
                    <label
                        style={buttonStyle || hideRadioInput ? Button : Paragraph2}
                        htmlFor={id}
                        className={[disabled ? `${inputType}-lock-label` : `${inputType}-label`, item.checked && 'checkedItem'].filter(Boolean).join(' ')}
                    >
                        {item.text}
                    </label>
                </div>
            );
        }
        default:
            return (<> </>);
    }
};

export class Form extends React.PureComponent {
    render() {
        const {
            groupClass,
            groupName,
            inputType,
            clickFunction,
            data,
            buttonStyle,
            disabled,
            labels = null,
            uniqueKey,
            hideRadioInput,
        } = this.props;

        return labels ? (
            <div className={groupClass}>
                {labels.map(({ key: labelKey, hide, text }) => (
                    <div className="dropdownLabelContainer">
                        <div key={labelKey} className={['dropdownLabel', hide ? 'hide' : 'show', hideRadioInput && 'hideRadioInput'].filter(Boolean).join(' ')} style={Subhead1}>
                            {text}
                        </div>
                        {data.filter(({ label }) => label === labelKey)
                            .map(createButtons(groupName, inputType, clickFunction, buttonStyle, disabled, uniqueKey, hideRadioInput))}
                    </div>
                ))}
            </div>
        ) : (
            <div className={groupClass}>
                {data.map(createButtons(groupName, inputType, clickFunction, buttonStyle, disabled, uniqueKey, hideRadioInput))}
            </div>
        );
    }
}

export default Form;
